import React, { useEffect, useState } from "react";
import Inputbox from "../../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Patientrequestupdates } from "../../../../api/helper";
import { ShowToast } from "../../../../helpers/ToastService";
import PatientInsurence from "./PatientInsurence";
import PatinetPrivatePay from "./PatinetPrivatePay";
import PatinetSubscriptionPlan from "./PatinetSubscriptionPlan";
import Membershipcard from "./Membershipcard";
import MemberPlan from "./MemberPlan";
import { useLocation, useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  CardDetails: Yup.string().required("Card Details is required"),
  PaymentMethod: Yup.string().required("Payment Method is required"),
});
const ClientPayment = ({ info, getDteails }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subtab = queryParams.get("subtab");

  const {
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [Insurance, setInsurance] = useState(true);
  const [PrivatePay, setPrivatePay] = useState(false);
  const [membershipcard, setmembershipcard] = useState(false);

  useEffect(() => {
    if (info) {
      setValue("PaymentMethod", info?.PaymentMethod?.PaymentMethod || "");
      setValue("CardDetails", info?.PaymentMethod?.CardDetails || "");
    }

    if (subtab === "membershipcard") {
      setInsurance(false);
      setmembershipcard(true);
      window.history.replaceState(null, "", "/ClientEditbyagency");
    }
    if (subtab === "PrivatePay") {
      setInsurance(false);
      setPrivatePay(true);
      window.history.replaceState(null, "", "/ClientEditbyagency");
    }
  }, [info, setValue]);

  const handlePaymentMethod = (method) => {
    setInsurance(method === "insurance");
    setPrivatePay(method === "privatePay");
    setmembershipcard(method === "membershipcard");
  };

  return (
    <div className="container_NotesTabScreen">
      <h1>Select Payment Method</h1>
      <div
        className="tabs-container__three"
        style={{ display: "flex", width: "100%", justifyContent: "left" }}
      />

      <p className="payment-description">
        Choose a method for payment. You can bill your insurance, pay privately,
        or subscribe to a plan for additional benefits.
      </p>
      <div className="payment-section">
        <div
          className={`payment-method ${Insurance ? "active" : ""}`}
          onClick={() => handlePaymentMethod("insurance")}
        >
          <input
            type="radio"
            id="insurance"
            name="payment_type"
            value="insurance"
            checked={Insurance}
            readOnly
          />
          <label htmlFor="insurance">🏥 Bill the Client's Insurance</label>
        </div>

        <div
          className={`payment-method ${PrivatePay ? "active" : ""}`}
          onClick={() => handlePaymentMethod("privatePay")}
          title="💳 Patient pays out-of-pocket for this service."
        >
          <input
            type="radio"
            id="private_pay"
            name="payment_type"
            value="private_pay"
            checked={PrivatePay}  
            readOnly
          />
          <label htmlFor="private_pay">💳 Private Pay (Out-of-Pocket)</label>
        </div>
        <div
          className={`payment-method ${membershipcard ? "active" : ""}`}
          onClick={() => handlePaymentMethod("membershipcard")}
        >
          <input
            type="radio"
            id="subscription"
            name="payment_type"
            value="subscription"
            checked={membershipcard}
            readOnly
          />
          <label>📦 Subscription Plan </label>
        </div>
      </div>

      {Insurance && <PatientInsurence info={info} />}
      {PrivatePay && <PatinetPrivatePay info={info} getDteails={getDteails} />}
      {membershipcard && <MemberPlan info={info} getDteails={getDteails} />}
    </div>
  );
};

export default ClientPayment;
